import { connect } from "react-redux";

import ConfirmDialog from "../components/ConfirmDialog";

// Action
import { closeConfirmDialog } from "../redux/modules/confirmDialog";

const mapStateToProps = state => ({ confirmDialog: state.confirmDialog });

const mapDispatchToProps = dispatch => ({
  handleClose: () => dispatch(closeConfirmDialog())
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmDialog);



// WEBPACK FOOTER //
// ./src/containers/ConfirmDialogContainer.js